import { useState } from "react";

import { Box } from "@/components/layout/flexbox";
import { NoteView } from "@/components/pieces/note/NoteView";
import { Confirmation } from "@/components/pieces/popup/Confirmation";
import { getUser } from "@/components/session/JwtTokenManager";
import {
  ClientNotesQueryDocument,
  useDeleteClientNoteMutation,
} from "@/graphql";
import { CustomerUser, Note as NoteType } from "@/types/users";

import { ClientNoteEditable } from "./NoteEditable";

interface NoteProps {
  user: CustomerUser;
  note: NoteType;
  isAuthor: boolean;
  loading: boolean;
}

export function Note({ user, note, isAuthor }: NoteProps) {
  const [edit, setEdit] = useState(false);
  const [confirmationVisible, setConfirmationVisible] = useState(false);

  const [deleteNote, { loading: deleteLoading }] = useDeleteClientNoteMutation({
    variables: {
      noteId: note.id,
    },
    refetchQueries: [
      {
        query: ClientNotesQueryDocument,
        variables: {
          customerId: user.id,
        },
      },
    ],
    awaitRefetchQueries: true,
  });

  const currentUser = getUser();

  const onEdit = () => {
    setEdit(true);
  };

  const onCancel = () => {
    setEdit(false);
  };

  return (
    <Box width={1}>
      {confirmationVisible ? (
        <Confirmation
          onNo={() => setConfirmationVisible(false)}
          onYes={deleteNote}
          msg="Remove this note?"
          loading={deleteLoading}
        />
      ) : edit ? (
        <ClientNoteEditable
          user={user}
          note={note}
          onSaveCompleted={onCancel}
          onCancel={onCancel}
        />
      ) : (
        <NoteView
          note={note}
          isAuthor={isAuthor}
          showAuthor={currentUser?.isSuperuser || false}
          onEdit={onEdit}
          onDelete={() => setConfirmationVisible(true)}
        />
      )}
    </Box>
  );
}
